import React from 'react'

const CandidateLogin = () => {
    return (
        <section className='p-4 md:p-24'>

            <div className='flex flex-col gap-5'>
                <h6 className="text-xl font-bold">Under Construction</h6>
            </div>


        </section>
    )
}

export default CandidateLogin